<template>
  <div>
    <v-toolbar
      tabs
      :style="{
        zIndex: 1,
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: '#ccc',
      }"
      height="80"
      card
      color="#fff"
    >
      <v-layout row align-center justify-space-between>
        <v-flex grow>
          <div
            class="mr-3"
            :style="{
              padding: '8px',
              display: 'inline-block',
              backgroundColor: '#ef565c',
              borderRadius: '0.5rem',
            }"
          >
            <v-icon color="#fff" medium>groups</v-icon>
          </div>
          <h1 style="display: inline">Rondas</h1>
        </v-flex>
      </v-layout>
      <template v-slot:extension>
        <v-speed-dial
          v-if="currentTab === 0"
          absolute
          bottom
          left
          direction="bottom"
          open-on-hover
          transition="scale-transition"
          style="bottom: 0"
        >
          <template v-slot:activator>
            <v-btn color="gradiente" dark fab>
              <v-icon>more_vert</v-icon>
              <v-icon>more_vert</v-icon>
            </v-btn>
          </template>
          <v-tooltip right>
            <router-link slot="activator" :to="{ name: 'createRound' }">
              <v-btn style="z-index: 99" color="gradiente" dark small fab>
                <v-icon style="width: 100%">add</v-icon>
              </v-btn>
            </router-link>
            <span>Crear nueva ronda</span>
          </v-tooltip>
          <v-tooltip right>
            <v-btn
              fab
              dark
              small
              color="gradiente"
              slot="activator"
              @click="downloadPdf"
            >
              <v-icon>file_download</v-icon>
            </v-btn>
            <span>Descargar PDF</span>
          </v-tooltip>
          <v-tooltip right>
            <v-btn
              fab
              dark
              small
              color="gradiente"
              slot="activator"
              @click="downloadXlsx"
            >
              <v-img
                :style="{ flex: '0 1 auto' }"
                height="28px"
                width="28px"
                :src="require('@/assets/reports/IconoCSV.png')"
              />
            </v-btn>
            <span>Descargar XLSX</span>
          </v-tooltip>
        </v-speed-dial>
        <v-tabs
          v-model="currentTab"
          color="transparent"
          style="margin-left: 70px"
        >
          <v-tab v-for="tab in tabs" :key="tab.id">
            <span class="text-uppercase">{{ tab.name }}</span>
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>
    <v-tabs-items v-model="currentTab">
      <v-tab-item>
        <CollegeRound @params="(currentParams) => (params = currentParams)" />
      </v-tab-item>
      <v-tab-item>
        <TutorRound />
      </v-tab-item>
    </v-tabs-items>
    <Loading text="Cargando..." v-model="modals.showLoading" />
    <Error :text="modals.errorMessage" v-model="modals.showError" />
  </div>
</template>

<script>
import { _downloadFileFromContentDisposition } from '../../../../utils/genericUtils.js'
import Error from '../../../Dialogs/Error.vue'
import Loading from '../../../Dialogs/Loading.vue'
import CollegeRound from './sections/collegeRound.vue'
import TutorRound from './sections/tutorRound.vue'

export default {
  components: {
    TutorRound,
    CollegeRound,
    Loading,
    Error,
  },
  mounted() {},
  data: () => ({
    modals: {
      showLoading: false,
      showError: false,
      errorMessage: '',
    },
    currentTab: 0,
    tabs: [
      { id: 1, name: 'CREADAS POR COLEGIO' },
      { id: 2, name: 'CREADAS POR TUTORES' },
    ],
    params: {},
  }),
  methods: {
    async downloadPdf() {
      this.modals.showLoading = true

      try {
        const response = await this.$store.dispatch(
          'round/getCollegeRoundsPdf',
          this.params
        )

        _downloadFileFromContentDisposition({ response })
      } catch (error) {
        console.log(error)
        this.modals.showError = true
        this.modals.errorMessage = 'Error al descargar archivo'
      } finally {
        this.modals.showLoading = false
      }
    },
    async downloadXlsx() {
      this.modals.showLoading = true

      try {
        const response = await this.$store.dispatch(
          'round/getCollegeRoundsXlsx',
          this.params
        )

        _downloadFileFromContentDisposition({ response })
      } catch (error) {
        console.log(error)
        this.modals.showError = true
        this.modals.errorMessage = 'Error al descargar archivo'
      } finally {
        this.modals.showLoading = false
      }
    },
  },
}
</script>
